// Lo que se dice de una persona bajo su nombre (su tarjeta del perfil público y la de «Perfiles de proveedores»): el rol que escribió en
// su perfil o, si no escribió ninguno, a qué se dedica: las categorías de sus servicios, las de más servicios primero y hasta 2
// («Música · Clases»). Sin nada de eso, nada (antes decía «Experto» de todos).
export const rolProveedor = (perfil, servicios) => {
  const rol = String(perfil?.rol || '').trim();
  if (rol) return rol;
  const cuantos = new Map();
  (servicios || []).forEach((s) => {
    if (s?.categoriaNombre) cuantos.set(s.categoriaNombre, (cuantos.get(s.categoriaNombre) || 0) + 1);
  });
  return [...cuantos.entries()].sort((a, b) => b[1] - a[1]).slice(0, 2).map(([nombre]) => nombre).join(' · ');
};
